import React from 'react'
import Layout from '../../components/layout'

import autoShare7e1407759069481 from './images/Auto-Share-7-e1407759069481.jpg'
import autoShare8e1407759085655 from './images/Auto-Share-8-e1407759085655.jpg'
import autoShare9e1407759106824 from './images/Auto-Share-9-e1407759106824.jpg'
import autoShare10e1407759121495 from './images/Auto-Share-10-e1407759121495.jpg'
import autoShare11e1407759136627 from './images/Auto-Share-11-e1407759136627.jpg'
import costumizeWelcomeMessage5e1403554704119 from './images/Costumize-Welcome-Message-5-e1403554704119.jpg'
import customizeBanner3be1403554305597 from './images/Customize-Banner-3b-e1403554305597.jpg'
import customizeBanners1e1403554318710 from './images/Customize-Banners-1-e1403554318710.jpg'
import customizeColours1a1e1403554331982 from './images/Customize-Colours-1a1-e1403554331982.jpg'
import customizeColours1ae1403553494504 from './images/Customize-Colours-1a-e1403553494504.jpg'
import customizeColours2e1403553594623 from './images/Customize-Colours-2-e1403553594623.jpg'
import customizeColours3e1403553680845 from './images/Customize-Colours-3-e1403553680845.jpg'
import customizeColours4e1403553691297 from './images/Customize-Colours-4-e1403553691297.jpg'
import customizeWelcomeMessage1e1403554696728 from './images/Customize-Welcome-Message-1-e1403554696728.jpg'
import customizeWelcomeMessage4ae1403554687297 from './images/Customize-Welcome-Message-4a-e1403554687297.jpg'
import howToInstall1e1403552583616 from './images/How-to-Install-1-e1403552583616.jpg'
import howToInstall2e1403552703261 from './images/How-to-Install-2-e1403552703261.jpg'
import howToInstall3e1403552781677 from './images/How-to-Install-3-e1403552781677.jpg'
import howToManageTabs11e1403552869495 from './images/How-to-manage-tabs-11-e1403552869495.jpg'
import howToManageTabs21e1403552946314 from './images/How-to-manage-tabs-21-e1403552946314.jpg'
import howToManageTabs31e1403553018931 from './images/How-to-manage-tabs-31-e1403553018931.jpg'
import howToPostajob1e1403553157689 from './images/How-to-post-a-job-1-e1403553157689.jpg'
import howToPostajob2e1403553292912 from './images/How-to-post-a-job-2-e1403553292912.jpg'
import howToPostajob3e1403553369745 from './images/How-to-post-a-job-3-e1403553369745.jpg'
import howToPostaJobe1403553223841 from './images/How-to-Post-a-Job-e1403553223841.jpg'
import addYouTubeVideo1e1403554495858 from './images/Add-YouTube-Video-1-e1403554495858.jpg'
import addYouTubeVideo2e1403554507847 from './images/Add-YouTube-Video-2-e1403554507847.jpg'
import addYouTubeVideo3e1403554518516 from './images/Add-YouTube-Video-3-e1403554518516.jpg'
import autoShare1e1407758983145 from './images/Auto-Share-1-e1407758983145.jpg'
import autoShare2e1407758998599 from './images/Auto-Share-2-e1407758998599.jpg'
import autoShare3e1407759014303 from './images/Auto-Share-3-e1407759014303.jpg'
import autoShare4e1407759028633 from './images/Auto-Share-4-e1407759028633.jpg'
import autoShare5e1407759042667 from './images/Auto-Share-5-e1407759042667.jpg'

const HowToUseJobcastPage = () => {
  return (
    <Layout heading="How to Use Jobcast">
      <h2>Getting Started</h2>
      <p>
        Learn all you need to know about getting started with the
        Jobcast App with these tutorials and videos!
      </p>
      <p>Click on each question to learn more.</p>
      <div>
        <h4 className="margin-t30">How to Install the Jobcast App</h4>
      </div>
      <div>
        <p>
          1 &#8211; Navigate to the Jobcast App Facebook Page and
          click on “Install App”:
        </p>
        <p>
          <img
            className="aligncenter"
            src={howToInstall1e1403552583616}
            alt="How-to-Install-1"
          />
        </p>
        <p>2 &#8211; Select “Install App” for your Company Page:</p>
        <p>
          <img
            className="aligncenter"
            src={howToInstall2e1403552703261}
            alt="How-to-Install-2"
          />
        </p>
        <p>
          3 &#8211; When you see the pink check mark then you know
          that you’re good to go!
        </p>
        <p>
          <img
            className="aligncenter"
            src={howToInstall3e1403552781677}
            alt="How-to-Install-3"
          />
        </p>
      </div>
      <div>
        <h4 className="margin-t30">
          How to Manage Your Facebook Tabs to Make Your Career Tab
          Visible
        </h4>
      </div>
      <div>
        <p>1 &#8211; Go to your Company Page and click on “More”:</p>
        <p>
          <img
            className="aligncenter"
            src={howToManageTabs11e1403552869495}
            alt="How-to-manage-tabs-1"
          />
        </p>
        <p>
          2 &#8211; From the “More” drop down, select “Manage Tabs”:
        </p>
        <p>
          <img
            className="aligncenter"
            src={howToManageTabs21e1403552946314}
            alt="How-to-manage-tabs-2"
          />
        </p>
        <p>
          3 &#8211; Click and drag your Career Tab towards the top of
          your tab list:
        </p>
        <p>
          <img
            className="aligncenter"
            src={howToManageTabs31e1403553018931}
            alt="How-to-manage-tabs-3"
          />
        </p>
        <p>4 &#8211; Save your changes!</p>
      </div>
      <div>
        <h4 className="margin-t30">How to Post a Job</h4>
      </div>
      <div>
        <p>1 &#8211; Go to your Career Page:</p>
        <p>
          <img
            className="aligncenter"
            src={howToPostajob1e1403553157689}
            alt="How-to-post-a-job-1"
          />
        </p>
        <p>2 &#8211; Click on ”Post a Job”:</p>
        <p>
          <img
            className="aligncenter"
            src={howToPostaJobe1403553223841}
            alt="How-to-Post-a-Job"
          />
        </p>
        <p>3 &#8211; Fill in all the necessary information!</p>
        <p>
          <img
            className="aligncenter"
            src={howToPostajob2e1403553292912}
            alt="How-to-post-a-job-2"
          />
        </p>
        <p>
          <strong>
            <em>
              Hot tip: you can add your own categories, if you do not
              see the ones you need.
            </em>
          </strong>
        </p>
        <p>
          4 &#8211; Insert the email address you would like to receive
          applications, then click on “Submit Job”:
        </p>
        <p>
          <img
            className="aligncenter"
            src={howToPostajob3e1403553369745}
            alt="How-to-post-a-job-3"
          />
        </p>
      </div>
      <div>
        <h4 className="margin-t30">
          How to Change Your Career Page Colours
        </h4>
      </div>
      <div>
        <p>1 &#8211; From your Career Page, click on “Customize”:</p>
        <p>
          <img
            className="aligncenter"
            src={customizeColours1ae1403553494504}
            alt="Customize-Colours-1a"
          />
        </p>
        <p>
          2 &#8211; From the settings tab, scroll down to the “Theme”
          drop down:
        </p>
        <p>
          <img
            className="aligncenter"
            src={customizeColours2e1403553594623}
            alt="Customize-Colours-2"
          />
        </p>
        <p>3 &#8211; Open the “Theme” drop down:</p>
        <p>
          <img
            className="aligncenter"
            src={customizeColours3e1403553680845}
            alt="Customize-Colours-3"
          />
        </p>
        <p>4 &#8211; Insert the HEX codes for your custom colours:</p>
        <p>
          <img
            className="aligncenter"
            src={customizeColours4e1403553691297}
            alt="Customize-Colours-4"
          />
        </p>
      </div>
      <div>
        <h4 className="margin-t30">Career Page Banner Dimensions</h4>
      </div>
      <div>
        <p>Top Banner: At least 810 pixels wide</p>
        <p>Side Banner: At least 320 pixels wide</p>
        <p>Bottom Banner: At least 810 pixels wide</p>
      </div>
      <div>
        <h4 className="margin-t30">
          How to Add Banners to Your Career Page
        </h4>
      </div>
      <div>
        <p>1 &#8211; From your Career Page, click on “Customize”:</p>
        <p>
          <img
            className="aligncenter"
            src={customizeColours1a1e1403554331982}
            alt="Customize-Colours-1a"
          />
        </p>
        <p>
          2 &#8211; From the settings tab, scroll down the “Banners”
          drop down:
        </p>
        <p>
          <img
            className="aligncenter"
            src={customizeBanners1e1403554318710}
            alt="Customize-Banners-1"
          />
        </p>
        <p>
          3 &#8211; Open the “Banners” drop down and upload a top,
          side, and bottom banner:
        </p>
        <p>
          <img
            className="aligncenter"
            src={customizeBanner3be1403554305597}
            alt="Customize-Banner-3b"
          />
        </p>
        <p>
          <strong>
            <em>
              Hot tip, ask team Jobcast about further customization!
            </em>
          </strong>
        </p>
      </div>
      <div>
        <h4 className="margin-t30">
          How to Add YouTube Video to Your Career Page:
        </h4>
      </div>
      <div>
        <p>1 &#8211; From your Career Page, click on “Customize”:</p>
        <p>
          <img
            className="aligncenter"
            src={customizeColours1a1e1403554331982}
            alt="Customize-Colours-1a"
          />
        </p>
        <p>
          2 &#8211; From the settings tab, scroll down to the
          “YouTube” drop down and open it:
        </p>
        <p>
          <img
            className="aligncenter"
            src={addYouTubeVideo1e1403554495858}
            alt="Add-YouTube-Video-1"
          />
        </p>
        <p>
          3 &#8211; Insert a link to the YouTube video you wish to
          use:
        </p>
        <p>
          <img
            className="aligncenter"
            src={addYouTubeVideo2e1403554507847}
            alt="Add-YouTube-Video-2"
          />
        </p>
        <p>
          If the link is working, you will see a preview of your
          video, like this:
        </p>
        <p>
          <img
            className="aligncenter"
            src={addYouTubeVideo3e1403554518516}
            alt="Add-YouTube-Video-3"
          />
        </p>
      </div>
      <div>
        <h4 className="margin-t30">
          How to Add a Welcome Message to Your Career Page
        </h4>
      </div>
      <div>
        <p>1 &#8211; From your Career Page, click on “Customize”:</p>
        <p>
          <img
            className="aligncenter"
            src={customizeColours1a1e1403554331982}
            alt="Customize-Colours-1a"
          />
        </p>
        <p>
          2 &#8211; Select the settings “Pages” tab, scroll down to
          the “Welcome Message” drop down:
        </p>
        <p>
          <img
            className="aligncenter"
            src={customizeWelcomeMessage1e1403554696728}
            alt="Customize-Welcome-Message-1"
          />
        </p>
        <p>3 &#8211; Open the “Welcome Message” drop down:</p>
        <p>
          <img
            className="aligncenter"
            src={customizeWelcomeMessage4ae1403554687297}
            alt="Customize-Welcome-Message-4a"
          />
        </p>
        <p>
          4 &#8211; Add your custom welcome message and click on “Save
          Changes”:
        </p>
        <p>
          <img
            className="aligncenter"
            src={costumizeWelcomeMessage5e1403554704119}
            alt="Costumize-Welcome-Message-5"
          />
        </p>
      </div>
      <div>
        <h4 className="margin-t30">
          How to set up Jobcast Auto-Share for one step social
          recruiting
        </h4>
      </div>
      <div>
        <p>
          1 &#8211; From the Admin section of the Jobcast App, click
          on &#8220;Customize&#8221;:
        </p>
        <p>
          <img
            className="aligncenter"
            src={autoShare1e1407758983145}
            alt="Auto-share"
          />
        </p>
        <p>
          2 &#8211; You will automatically be directed to the
          &#8220;Settings&#8221; tab, from here, click on the clock
          icon:
        </p>
        <p>
          <img
            className="aligncenter"
            src={autoShare2e1407758998599}
            alt="Auto-share"
          />
        </p>
        <p>
          3 &#8211; Click on the &#8220;Add Scheduled Post&#8221; drop
          down:
        </p>
        <p>
          <img
            className="aligncenter"
            src={autoShare3e1407759014303}
            alt="Auto-share"
          />
        </p>
        <p>
          4 &#8211; Select the social network you wish to automate
          sharing for:
        </p>
        <p>
          <img
            className="aligncenter"
            src={autoShare4e1407759028633}
            alt="Auto-share"
          />
        </p>
        <p>
          5 &#8211; Authorize the Jobcast app to share on your behalf:
        </p>
        <p>
          <img
            className="aligncenter"
            src={autoShare5e1407759042667}
            alt="Auto-share"
          />
        </p>
        <p>
          6 &#8211; Fill in all relevant information (make sure to
          include hashtags, like #hiring, for Twitter and Facebook):
        </p>
        <p>
          <img
            className="aligncenter"
            src={autoShare8e1407759085655}
            alt="Auto-share"
          />
        </p>
        <p>
          7 &#8211; Select the days, rate, and the sharing window for
          sharing your job ads, and tick the &#8220;Re-Share&#8221;
          box if relevant. Click &#8220;Save&#8221;:
        </p>
        <p>
          <img
            className="aligncenter"
            src={autoShare7e1407759069481}
            alt="Auto-share"
          />
        </p>
        <p>8 &#8211; Review your handy work:</p>
        <p>
          <img
            className="aligncenter"
            src={autoShare8e1407759085655}
            alt="Auto-share"
          />
        </p>
        <p>
          9 &#8211; If you find an error, simply hover over the spot
          you need to change and click &#8220;Edit&#8221;:
        </p>
        <p>
          <img
            className="aligncenter"
            src={autoShare9e1407759106824}
            alt="Auto-share"
          />
        </p>
        <p>
          10 &#8211; Add your Facebook Page, your Facebook Account,
          your Twitter, Your LinkedIn, and your LinkedIn Company Page:
        </p>
        <p>
          <img
            className="aligncenter"
            src={autoShare10e1407759121495}
            alt="Auto-share"
          />
        </p>
        <p>
          11 &#8211; Here&#8217;s what your job ad will look like once
          shared to LinkedIn (imagine your logo, face, and hopefully
          fewer InMails!):
        </p>
        <p>
          <img
            className="aligncenter"
            src={autoShare11e1407759136627}
            alt="Auto-share"
          />
        </p>
      </div>
    </Layout>
  )
}

export default HowToUseJobcastPage
